// Styles for LogoBlock go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLogoBlock = styled.div`
  .container-sm {
    padding: 0 ${toRem(8)} !important;
    @media ${baseVariables.mediaQuery.sm} {
      padding: 0 !important;
    }
    ul {
      justify-content: center;
      margin: ${toRem(32)} 0;
    }
  }

  [data-component-name='m-ui-library-IconBlock'] {
    border-radius: unset;
    box-shadow: unset;
    border: unset;
    justify-content: center;
    .iconblock {
      margin: ${toRem(32)} 0;
      align-items: center;
      .iconblock-icon {
        & + div {
          align-items: center;
        }
      }
      .iconblock-content {
        margin-bottom: ${toRem(12)};
      }
      .iconblock-body {
        .heading {
          padding: 0;
        }
        .description {
          color: var(--t-brand-fg-color);
        }
        .iconblock-button {
          margin-top: ${toRem(12)};
          color: var(--t-button-tertiary-color);
          background-color: var(--brand-bg-color);
        }
      }
    }
  }
  .vcc-container {
    margin-bottom: 0;
    .container-sm {
      ul {
        margin: 0 auto;
      }
    }
  }
`;

export const StyledLogoBlockContainer = styled.div`
  clear: both;
`;
